import { ColourPalettes } from './components/ColourPalettes';
import { ErrorMessage, Heading, Loading } from 'components/CommonComponents';
import { Grid, GridItem } from 'components/Grid';
import { PAD_MEDIUM_NUMBER } from 'providers/designSystem';
import { EditColourPalettesMenu } from './components/EditColourPalettesMenu';
import { useColourPalettes } from 'hooks/useColourPalettes';

export const ColourPalettesPage = () => {
    const [colourPalettes, setColourPalettes] = useColourPalettes();
    return (
        <Grid numberOfColumns={1} gap={PAD_MEDIUM_NUMBER}>
            <Heading>Colour Palettes</Heading>
            {colourPalettes?.loading && <Loading />}
            {colourPalettes?.error && <ErrorMessage />}
            {colourPalettes?.result && (
                <>
                    <GridItem justifySelf="end">
                        <EditColourPalettesMenu setColourPalettes={setColourPalettes} />
                    </GridItem>
                    <ColourPalettes colourPalettes={colourPalettes} />
                </>
            )}
        </Grid>
    );
};
